// @ts-nocheck 180abfc7
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['design_section_label_explore_checkboxgroup'],
      sections: [
        addPanel.sections.getSections().developer.checkboxGroupSection,
      ],
    };
  },
};
